"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeImg = void 0;
var React = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode");
var styles = _interopRequireWildcard(require("./QRCodeImg.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const QRCodeImg = _ref => {
  let {
    text,
    width,
    color,
    scale
  } = _ref;
  const imageRef = React.useRef(null);
  const doubleWidth = width ? width * 2 : undefined;
  React.useEffect(() => {
    (0, _qrcode.toDataURL)(text, {
      errorCorrectionLevel: 'Q',
      width: doubleWidth,
      color,
      margin: 0,
      scale
    }, function (err, url) {
      if (err) {
        throw err;
      }
      if (imageRef && imageRef.current) {
        imageRef.current.src = url;
      }
    });
  }, [text, doubleWidth, color, scale]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${width}px`,
      height: `${width}px`
    },
    className: styles['container']
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['img'],
    ref: imageRef,
    src: "",
    alt: ""
  }));
};
exports.QRCodeImg = QRCodeImg;